<script>

function defaultTitle(severity){
  switch (severity) {
    case 'success':
      return 'Sucesso';
    case 'warn':
      return 'Aviso';
    case 'error':
      return 'Erro';
    case 'info':
    default:
      return 'Info';
  }
};

export default {
  methods: {
    $notify(msg = '', severity = null, summary = null, lifetime = 3500) {
      this.$toast.add({
        severity: severity || 'info',
        summary: summary || defaultTitle(severity),
        detail: msg,
        life: lifetime
      });
    },
    $drop(drop = '', event) {
      this.$refs[drop].$.refs.drop.toggle(event);
    },
  },
};
</script>